import React from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import EmbeddedMimecastApp from "./EmbeddedMimecastApp";
const MimecastApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("mimecast.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("mimecast.app.description"))), /* @__PURE__ */ React.createElement(EmbeddedMimecastApp, null));
};
export default MimecastApp;
